module.exports = __webpack_public_path__ + "img/intro_3.4340d656.jpeg";